export default __webpack_public_path__ + "static/media/icn_user.9a3004ed.svg";